<template>
  <v-row class="py-1 ma-0" no-gutters>
    <v-col class="mb-2 mb-md-0" cols="12" md="auto">
      <v-img
        class="cart-product-image"
        width="205"
        md-width="auto"
        :src="image"
        cover
      />
    </v-col>
    <v-col class="px-md-2 pl-0">
      <h3>{{ name }}</h3>
      <p>{{ sku }}</p>
    </v-col>
    <v-col class="ms-auto pl-2" cols="auto" align-self="end">
      <v-responsive width="100">
        <v-text-field
          class="pb-2"
          type="number"
          :min="0"
          :max="999"
          v-model="localQuantity"
          @update:modelValue="updateProductQuantity"
          variant="outlined"
          control-variant="stacked"
          hide-details="auto"
          inset
        ></v-text-field>
        <v-hover>
          <template v-slot:default="{ isHovering, props }">
            <a
              v-bind="props"
              @click="deleteProduct"
              class="cursor-pointer"
              :class="{ 'text-decoration-underline': isHovering }"
              >{{ $t("cart.product.delete")
              }}<v-icon icon="mdi-delete-outline" size="small"></v-icon
            ></a>
          </template>
        </v-hover>
      </v-responsive>
      <v-col class="px-0 py-0 pt-3" align-self="end">
        <strong class="py-0">{{
          $currency.formatCurrency(quantity * price)
        }}</strong>
      </v-col>
    </v-col>
  </v-row>
</template>

<script setup>
const { $currency } = useNuxtApp();

const props = defineProps({
  id: String,
  name: String,
  image: String,
  quantity: Number,
  price: Number,
  sku: String,
});

const emit = defineEmits(["updateProductQuantity", "deleteProduct"]);

const localQuantity = ref(props.quantity);

watch(() => props.quantity, (newQuantity) => {
  localQuantity.value = newQuantity;
});

function updateProductQuantity(updatedQuantity) {
  emit("updateProductQuantity", {
    sku: props.sku,
    name: props.name,
    updatedQuantity: updatedQuantity - props.quantity,
    revertQuantity: () => { localQuantity.value = props.quantity; }
  });
}

function deleteProduct() {
  emit("deleteProduct", { sku: props.sku });
}
</script>
